import { Component, Input } from '@angular/core';
import { CNAEViewer } from '../../adapters';
@Component({
    selector: 'sgt-cnaes-view',
    templateUrl: './cnaes-view.component.html',
    styleUrls: ['./cnaes-view.component.less']
})
export class CNAEsViewComponent {
    @Input() cnaePrincipal: CNAEViewer;
    @Input() cnaesSecundarias: CNAEViewer[];
}
